module.exports = __webpack_public_path__ + "static/media/Group 31.02ac04ea.jpg";